import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser'
import ProjectCard from 'components/projects/ProjectCard'
import { PROJECTS } from 'components/projects/constants'
import Image from 'next/image'
import Head from 'next/head'
import classNames from 'classnames'
import { Facebook, Instagram } from 'components/assets/svg'
import heroImage from '../../../public/images/features/projects/overview-header.jpg'
import styles from './ProjectsOverview.module.scss'
import { TITLE_POSTFIX } from 'constants/seo'

const ProjectsOverview: FC = () => {
  // I18N
  const { t } = useTranslation(['projects', 'projectFestivals'])

  return (
    <>
      {/* SEO */}
      <Head>
        <title>
          {t('seoTitle', 'Projecten')} {TITLE_POSTFIX}
        </title>
        <meta property="og:title" content={`${t('seoTitle')} ${TITLE_POSTFIX}`} key="title" />
      </Head>

      <div className={styles.projects}>
        {/* PAGE CONTENT */}
        <section className={classNames('section', styles.hero)}>
          <div className="container has-bg-image">
            <h1 className={styles.title}>
              {parse(t('title', 'Meer dan alleen energie<br /><span>Ontdek wat</span><br /><span>we nog doen</span>'))}
            </h1>
          </div>

          <Image
            priority
            src={heroImage}
            layout="fill"
            objectFit="cover"
            objectPosition="center 75%"
            placeholder="blur"
            alt="Bolt Energie"
          />
        </section>

        <section className="section">
          <div className="container">
            <div className="columns">
              {PROJECTS.map((project) => {
                const { id } = project

                return (
                  <div key={id} className="column is-one-third">
                    <ProjectCard project={project} />
                  </div>
                )
              })}
            </div>
          </div>
        </section>

        <section className={classNames('section is-dark', styles.cta)}>
          <div className="container">
            <div className={styles.content}>
              <h2>
                {parse(t('projectFestivals:ctaTitle', 'Doe mee met deze energierevolutie.<br />Follow us <span>@boltenergie!</span>'))}
              </h2>
              <div className={styles['social-icons']}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/boltenergie"
                  className={styles['icon-container']}
                >
                  <Instagram className={styles.icon} />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/boltenergie/"
                  className={styles['icon-container']}
                >
                  <Facebook className={styles.icon} />
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default ProjectsOverview
